export default __webpack_public_path__ + "static/char-v-sp03-jam-f4099ce6f79db6bcea0d81ed72686525.mp4";